import React, { FC } from "react";
import classNames from "classnames";
import { Fade } from "react-awesome-reveal";
import { useTranslation } from "react-i18next";
import { StaticImage } from "gatsby-plugin-image";
import { DEFAULT_FADE_DURATION } from "@app/constants";
import { Hero } from "../common";
import { ContactForm } from "./components/contact-form/ContactForm";

export const FinancialReports: FC = () => {
  const { t } = useTranslation("p_financial-reports");

  return (
    <div
      className={classNames(
        "flex w-full flex-col items-center gap-20 pb-20",
        "lg:gap-25 lg:pb-25",
        "xl:gap-40 xl:pb-40",
      )}
    >
      <Hero title={t("hero_title")} subtitle={t("hero_subtitle")} />
      <div
        className={classNames(
          "flex flex-col gap-5 px-5",
          "lg:flex-row lg:justify-between lg:gap-15 lg:px-16",
          "xl:px-24",
          "xxl:max-w-container-wide",
        )}
      >
        <div className={classNames("lg:flex-1", "xxl:w-[48%] xxl:flex-none")}>
          <Fade duration={DEFAULT_FADE_DURATION} triggerOnce>
            <StaticImage
              src={"./Amandine_Support.webp"}
              alt="Get financial report"
              className={classNames("rounded-lg")}
            />
          </Fade>
        </div>
        <div className={classNames("lg:flex-1", "xxl:w-2/5 xxl:flex-none")}>
          <ContactForm />
        </div>
      </div>
    </div>
  );
};
